/* The specimen sheet's motion.
   Entrance is opt-in at runtime: the hidden states only exist once .sm-ready is
   on the body, so a failed script, a missing IntersectionObserver or a reader
   who prefers reduced motion all get the page fully visible. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) { return; }

  var sheets = [].slice.call(document.querySelectorAll('[data-sheet]'));
  /* The stylesheet loads on every page template; most of them hold no sheets,
     and sm-ready is what turns the hidden states on. */
  if (!sheets.length) { return; }
  document.body.classList.add('sm-ready');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var vids = e.target.querySelectorAll('video');
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        [].forEach.call(vids, function (v) {
          if (!v.src) {
            v.src = v.dataset.src;
            /* A clip whose opening frames are unusable starts past them, and
               goes back there on every loop rather than to zero. */
            if (v.dataset.start) {
              var from = parseFloat(v.dataset.start);
              var seek = function () { v.currentTime = from; };
              v.addEventListener('loadedmetadata', seek);
              v.addEventListener('seeked', function () {
                if (v.currentTime < from - 0.1) { seek(); }
              });
            }
          }
          if (!reduced) { v.play().catch(function () {}); }
        });
      } else {
        [].forEach.call(vids, function (v) { v.pause(); });  // nothing decodes off screen
      }
    });
  }, { threshold: 0.2 });
  sheets.forEach(function (s) { io.observe(s); });

  // Anything already on screen at first paint is revealed outright, no delay.
  requestAnimationFrame(function () {
    sheets.forEach(function (s) {
      if (s.getBoundingClientRect().top < window.innerHeight) { s.classList.add('is-in'); }
    });
  });
})();
